import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import UserComponent from './User/User.container';
import { Link } from 'react-router-dom';
import storage from '../higherOrder/storage';
import { getPath } from 'utils/Router';
import eventEmitter from '../utils/EventEmitter';

const headerImages = {
    logo: require('img/main-logo-exteneded.svg'),
    cross: require('img/cross.svg'),
};

function Header({ isOpen, setStorage }) {
    const [isOpenSidebar, setIsOpenSidebar] = useState(!!isOpen);

    const queryDOM = () => {
        const root = document.getElementById('page-wrapper');
        return {
            root,
            body: document.body,
            content: root?.querySelector('.wrapper-content') || null,
            heading: root?.querySelector('.page-heading') || null,
            notification: root?.querySelector('.notification') || null,
            chart: root?.querySelector('.chart_container') || null,
            period: root?.querySelector('.period_wrapper') || null,
            burger: root?.querySelector('.top-header__menu-toggle') || null,
        };
    };

    const addSidebarClasses = useCallback(() => {
        const { body, content, heading, notification, chart, period, burger } = queryDOM();
        body?.classList.add('open-sidebar');
        content?.classList.add('active-sidebar');
        heading?.classList.add('active-sidebar');
        notification?.classList.add('active-sidebar');
        chart?.classList.add('active-sidebar');
        period?.classList.add('active-sidebar');
        burger?.classList.add('active');
    }, []);

    const removeSidebarClasses = useCallback(() => {
        const { body, content, heading, notification, chart, period, burger } = queryDOM();
        body?.classList.remove('open-sidebar');
        content?.classList.remove('active-sidebar');
        heading?.classList.remove('active-sidebar');
        notification?.classList.remove('active-sidebar');
        chart?.classList.remove('active-sidebar');
        period?.classList.remove('active-sidebar');
        burger?.classList.remove('active');
    }, []);

    const onOverlayClick = useCallback(() => {
        removeSidebarClasses();
        setStorage({ isOpen: false });
        setIsOpenSidebar(false);
    }, [removeSidebarClasses, setStorage]);

    useEffect(() => {
        setIsOpenSidebar(!!isOpen);
        
        if (isOpen) {
            addSidebarClasses();
        } else {
            removeSidebarClasses();
        }
    }, [isOpen, addSidebarClasses, removeSidebarClasses]);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && isOpenSidebar) {
                onOverlayClick();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpenSidebar, onOverlayClick]);

    useEffect(() => {
        const handleGlobalMenuToggle = () => {
            onClickToggle();
        };

        eventEmitter.on('toggleMenu', handleGlobalMenuToggle);
        return () => eventEmitter.off('toggleMenu', handleGlobalMenuToggle);
    }, [onClickToggle]);

    const onClickToggle = useCallback(
        () => {
            const willOpen = !isOpenSidebar;

            
            if (typeof setStorage !== 'function') {
                console.error('Header: setStorage is not a function:', setStorage);
                return;
            }
            
            setStorage({ isOpen: willOpen });
            setIsOpenSidebar(willOpen);

            if (willOpen) {
                addSidebarClasses();
            } else {
                removeSidebarClasses();
            }
        },
        [isOpenSidebar, setStorage, addSidebarClasses, removeSidebarClasses]
    );

    const onCloseMenu = useCallback(() => {
        const { burger } = queryDOM();
        if (burger?.classList.contains('active')) onOverlayClick();
    }, [onOverlayClick]);

    return (
        <header className="top-header">
            <div className="logo-block">
                <button
                    type="button"
                    className="top-header__menu-toggle"
                    aria-expanded={isOpenSidebar}
                    aria-controls="sidebar"
                    onClick={onClickToggle}
                >
                    <span />
                </button>
                <Link to={getPath('dashboard')} data-link onClick={onCloseMenu}>
                    <img className="logo" src={headerImages.logo} alt="CPA Dashboard" />
                </Link>
            </div>

            <div className="top-header__left" />
            <div className="top-header__right">
                <UserComponent />
            </div>
        </header>
    );
}

Header.propTypes = {
    isOpen: PropTypes.bool,
    setStorage: PropTypes.func.isRequired,
};

export default storage(Header, 'sidebar');
